import {
  Lock,
  MapPin,
  Share2,
  ShieldAlert,
  UserCog,
  Info,
} from "lucide-react";
import {useConfig} from "../../components/Context/ConfigContext";

const PrivacyPolicy = () => {
    const {configData} = useConfig();

    const policyData = [
    {
      id: 1,
      icon: <Lock size={18} />,
      title: "Information We Collect",
      content: `We may collect:
• Name, phone number, email
• Location data (latitude & longitude)
• Store details (for store owners)
• Order and transaction data`,
    },
    {
      id: 2,
      icon: <Info size={18} />,
      title: "How We Use Information",
      content: `We use your data to:
• Provide nearby store recommendations
• Process and manage orders
• Send notifications
• Improve platform experience`,
    },
    {
      id: 3,
      icon: <MapPin size={18} />,
      title: "Location Data",
      content: `We collect location data to show nearby stores.
Users can manually pin their address.`,
    },
    {
      id: 4,
      icon: <Share2 size={18} />,
      title: "Data Sharing",
      content: `We do not sell your data.
We may share:
• Customer details with store owners for order fulfillment
• Data with legal authorities if required`,
    },
    {
      id: 5,
      icon: <ShieldAlert size={18} />,
      title: "Data Security",
      content:
        "We implement security measures to protect your data, but no system is 100% secure.",
    },
    {
      id: 6,
      icon: <UserCog size={18} />,
      title: "User Control",
      content: `Users can:
• Update their profile
• Disable location access (may affect features)`,
    },
    {
      id: 7,
      icon: <Info size={18} />,
      title: "Data Retention",
      content:
        "We retain data as long as necessary for service and legal compliance.",
    },
    {
      id: 8,
      icon: <Info size={18} />,
      title: "Children's Privacy",
      content: "Our platform is not intended for users under 18.",
    },
    {
      id: 9,
      icon: <Info size={18} />,
      title: "Changes to Privacy Policy",
      content: "We may update this policy periodically.",
    },
  ];
  return (
    <div className="min-h-screen bg-zinc-50 dark:bg-slate-950 font-sans">
      {/* HEADER */}
      <div className="sticky top-0 z-50 bg-white/80 dark:bg-slate-950/80 backdrop-blur border-b border-zinc-200 dark:border-slate-800">
        <div className="max-w-5xl mx-auto px-6 py-6 text-center">
          <h1 className="text-3xl font-black text-zinc-900 dark:text-white">
            🔒 Privacy Policy
          </h1>
          <p className="text-sm text-zinc-500 dark:text-slate-400 mt-2">
            Your data safety is important to us
          </p>
          <p className="text-xs text-zinc-400 mt-1">
            Last Updated: 20 Apr,2026
          </p>
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-5xl mx-auto px-6 py-10 space-y-6">
        {policyData.map((item) => (
          <div
            key={item.id}
            className="bg-white dark:bg-slate-900 border border-zinc-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm hover:shadow-md transition"
          >
            <div className="flex items-start gap-4">
              {/* ICON */}
              <div className="p-3 rounded-xl bg-orange-500 text-white">
                {item.icon}
              </div>

              {/* TEXT */}
              <div>
                <h3 className="font-black text-lg text-zinc-900 dark:text-white mb-2">
                  {item.id}. {item.title}
                </h3>

                <p className="text-sm text-zinc-600 dark:text-slate-300 whitespace-pre-line leading-relaxed">
                  {item.content}
                </p>
              </div>
            </div>
          </div>
        ))}

        <div className="mt-10 text-center">
          <p className="text-sm text-zinc-500 dark:text-slate-400">
            For any queries, contact us at{" "}
            <a
              href={`mailto:${configData?.support_email}`}
              className="text-orange-500 font-semibold hover:underline"
            >
              {configData?.support_email}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
